export default __webpack_public_path__ + "static/media/ali_1.f5adb3b3.jpg";